var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { compact } from 'lodash';
import { classNames } from '@shapeable/utils';
import { ExplorerTab } from './explorer-tab';
import { TabsContainer } from '../elements/tabs-container';
import { useLang } from '../hooks/use-lang';
import { useReady } from '../hooks/use-ready';
import { useInView } from 'react-intersection-observer';
var cls = classNames('explorer-tabs');
export var ExplorerTabsDefaultProps = {
  activeTab: 'all',
  tabs: []
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n    flex-direction: row;\n    border-top: 1px solid ", ";\n\n    ", "\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n    flex-direction: row;\n    border-top: 1px solid ", ";\n\n    ", "\n  "])), theme.COLOR('line-very-subtle'), function (_a) {
    var isSticky = _a.isSticky;
    return isSticky && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-bottom: 1px solid ", ";\n      position: fixed;\n      top: 64px;\n      left: 0;\n      right: 0;\n      z-index: 299;\n      width: 100%;\n      /* animation-delay: 0;\n      animation: slideDown 0.2s forwards; */\n\n      @keyframes slideDown {\n        from { transform: translateY(-100%); }\n        to { transform: translateY(0); }\n      }\n\n    "], ["\n      border-bottom: 1px solid ", ";\n      position: fixed;\n      top: 64px;\n      left: 0;\n      right: 0;\n      z-index: 299;\n      width: 100%;\n      /* animation-delay: 0;\n      animation: slideDown 0.2s forwards; */\n\n      @keyframes slideDown {\n        from { transform: translateY(-100%); }\n        to { transform: translateY(0); }\n      }\n\n    "])), theme.COLOR('explorerTabs.line', 'brightWarm'));
  }),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    border-top: none;\n    ", "\n  "], ["\n    border-top: none;\n    ", "\n  "])), function (_a) {
    var isSticky = _a.isSticky;
    return isSticky && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: calc(100% - ", ");\n    "], ["\n      width: calc(100% - ", ");\n    "])), theme.UNIT(14));
  })
});
var TabsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TabStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var BufferStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    height: ", ";\n    width: 100%;\n  "], ["\n    height: ", ";\n    width: 100%;\n  "])), theme.UNIT(9)),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    height: ", ";\n  "], ["\n    height: ", ";\n  "])), theme.UNIT(11))
});
var ViewCheckStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    height: 0;\n    font-size: 0;\n  "], ["\n    height: 0;\n    font-size: 0;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ViewCheck: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ViewCheckStyles),
  Buffer: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), BufferStyles),
  Tabs: styled(TabsContainer)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles),
  Tab: styled(ExplorerTab)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TabStyles)
};
export var ExplorerTabs = function (props) {
  var className = props.className,
    onTabClick = props.onTabClick,
    tabs = props.tabs,
    activeTab = props.activeTab,
    colors = props.colors;
  var isReady = useReady();
  if (!isReady) {
    return null;
  }
  var _a = __read(useState(false), 2),
    isSticky = _a[0],
    setSticky = _a[1];
  var _b = useInView({
      rootMargin: '-10px 0px 0px 0px'
    }),
    ref = _b.ref,
    inView = _b.inView;
  var _c = __read(useState(false), 2),
    delayed = _c[0],
    setDelayed = _c[1];
  // stops a flicker of fixed tabs
  useEffect(function () {
    setTimeout(function () {
      setDelayed(true);
    }, 500);
  }, []);
  useEffect(function () {
    if (delayed) {
      setSticky(!inView);
    }
  }, [inView, isReady, delayed]);
  var t = useLang();
  var handleClick = function (tab) {
    return function () {
      if (onTabClick) {
        onTabClick(tab.id, tab.suffix);
      }
    };
  };
  return React.createElement(React.Fragment, null, React.createElement(My.ViewCheck, {
    ref: ref
  }), isSticky && React.createElement(My.Buffer, null), React.createElement(My.Container, {
    isSticky: isSticky
  }, React.createElement(My.Tabs, {
    showFade: false,
    className: cls.name(className)
  }, compact(tabs).map(function (tab, index) {
    var nextTab = index < tabs.length - 1 ? tabs[index + 1] : null;
    var nextIsActive = nextTab && nextTab.id === activeTab;
    var isLast = index === tabs.length - 1;
    var isFirst = index === 0;
    var hasLabelAndIcon = !!tab.label && !!tab.icon;
    return React.createElement(My.Tab, {
      isLoading: tab.isLoading,
      onClick: handleClick(tab),
      key: tab.id,
      count: tab.count,
      nextIsActive: nextIsActive,
      isLast: isLast,
      isFirst: isFirst,
      isActive: activeTab === tab.id,
      hasIconLabel: hasLabelAndIcon,
      icon: tab.icon,
      label: tab.label,
      isSticky: isSticky,
      colors: colors
    }, !hasLabelAndIcon && (tab.label || tab.icon));
  }))));
};
ExplorerTabs.cls = cls;
ExplorerTabs.defaultProps = ExplorerTabsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;